import { render, staticRenderFns } from "./article-builder.vue?vue&type=template&id=2a340576&scoped=true"
import script from "./article-builder.vue?vue&type=script&lang=js"
export * from "./article-builder.vue?vue&type=script&lang=js"
import style0 from "./article-builder.vue?vue&type=style&index=0&id=2a340576&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2a340576",
  null
  
)

export default component.exports